import React from 'react'
import {FormattedMessage} from 'react-intl'
import {UserType} from '../../../config/constants'
import {useUserType} from '../../hocs/hooks'

const SignupTitle = () => {
  const userType = useUserType()
  return <>
    <div className="form-group text-center font-weight-bold">
      {userType === UserType.user
        ? <FormattedMessage id="signUpTitle.user" defaultMessage="New driver registration"/>
        : userType === UserType.host
          ? <FormattedMessage id="signUpTitle.host" defaultMessage="New host registration"/>
          : userType === UserType.author
            ? <FormattedMessage id="signUpTitle.writer" defaultMessage="New writer registration"/>
            : userType === UserType.holder
              ? <FormattedMessage id="signUpTitle.holder" defaultMessage="New holder registration"/>
              : <FormattedMessage id="signUpTitle.admin" defaultMessage="New admin registration"/>
      }
    </div>
  </>
}
SignupTitle.displayName = 'SignupTitle'
export default SignupTitle
